import { render, staticRenderFns } from "./edit-role.vue?vue&type=template&id=46d9a24b&scoped=true&"
import script from "./edit-role.vue?vue&type=script&lang=js&"
export * from "./edit-role.vue?vue&type=script&lang=js&"
import style0 from "./edit-role.vue?vue&type=style&index=0&id=46d9a24b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d9a24b",
  null
  
)

export default component.exports